export default
{
    // types: facebook, twitter, youtube, link
    name: 'app-btn-social-link',

    props:
    {
        url: { type: String },
        type: { type: String, default: 'twitter' },
        size: { type: String, default: 'medium' }
    },

    methods:
    {
        _onClick()
        {
            if (window.dataLayer)
            {
                window.dataLayer.push({
                    event: 'gfinity.social',
                    'gfinity.social.network': this.type,
                    'gfinity.social.action': 'click',
                    'gfinity.social.resource': this.url
                })
            }
            else
            {
                console.error('Google Tag Manager: dataLayer not defined')
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/components/app-btn-social-link/script.js